<script lang="ts">
  import { onMount, untrack } from "svelte"
  import type { OrganizationFrame } from "@kontextwerk/control-web-client"
  import type { OrgaViewFrameContext } from "../../../../../../context"
  import { createUsersDirectory } from "../../_shared/_logic/users-directory"
  import RolesTable from "./_modules/roles-table"

  const {
    viewFrameContext,
    organization,
  }: { viewFrameContext: OrgaViewFrameContext; organization: OrganizationFrame } = $props()

  // One directory per mounted organization owner; the parent keys this tab by organization.
  const directory = untrack(() =>
    createUsersDirectory({ organizationId: organization.id, roles: true, manage: false }),
  )

  onMount(() => {
    void directory.load()

    return () => directory.dispose()
  })
</script>

{#if directory.available}
  <RolesTable {organization} {directory} permissions={viewFrameContext.permissions} />
{:else}
  <p class="state" role="status">Zugang zu den Rollen nicht bestätigt.</p>
{/if}

<style lang="less">
  .state {
    margin: 0;
    color: var(--text-invers-100);
  }
</style>
